<script>
  import {
    pageToLoad,
    openWorkshops,
    selectedWorkshopID,
  } from "../scripts/stores.js";
  import { formatTimestamp, formatTimeRange } from "../scripts/utils.js";

  console.log("workshops page!");

  let nextPage = "workshopDetail";

  const makeWorkshopsArray = (wsObject) => {
    const arr = Object.values(wsObject);
    arr.sort((a, b) => {
      return a.startTime.seconds - b.startTime.seconds;
    });
    return arr;
  };

  let workshopsArrayNew;
  $: workshopsArrayNew = makeWorkshopsArray($openWorkshops);
  $: console.log($openWorkshops);

  const learnMore = (id) => {
    selectedWorkshopID.set(id);
    pageToLoad.set(nextPage);
  };
</script>

<main class="page">
  {#if Object.keys(workshopsArrayNew).length == 0}
    <p>There are no workshops to display.</p>
  {/if}
  {#each workshopsArrayNew as { title, startTime, endTime, id }}
    <div class="wrapper">
      <div>
        <div class="title"><h3>{title}</h3></div>
        <div class="info-row">
          <div class="mini-icon">
            <img src="./images/calendar-icon.svg" alt="Date" width="15px" />
          </div>
          <div class="info-text">{formatTimestamp(startTime).date}</div>
        </div>
        <div class="info-row">
          <div class="mini-icon">
            <img src="./images/clock-icon.svg" alt="Date" width="15px" />
          </div>
          <div class="info-text">{formatTimeRange(startTime, endTime)}</div>
        </div>
      </div>
      <div class="button-primary" on:click={() => learnMore(id)}>
        Learn More
      </div>
    </div>
  {/each}
</main>

<style>
  .title {
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
    background-color: #212121;
    color: #f5dd42;
    text-align: center;
    outline: 2px solid #f5dd42;
    outline-offset: -5px;
    border-radius: 10px;
    margin-bottom: 10px;
  }
  h3 {
    font-size: 1.5em;
  }
  .wrapper {
    padding: 20px 10px;
    /* background-color: #ccc; */
    /* border-radius: 10px; */
    border-top: 2px dashed #ccc;
    margin: 5px;
  }
  .info-row {
    display: flex;
    align-items: center;
    padding-top: 4px;
    padding-bottom: 4px;
    justify-content: center;
  }
  .mini-icon {
    display: inline-flex;
    margin-right: 5px;
  }
</style>
